import { render, staticRenderFns } from "./PlayersFilter.vue?vue&type=template&id=067ae746&scoped=true"
import script from "./PlayersFilter.js?vue&type=script&lang=js&external"
export * from "./PlayersFilter.js?vue&type=script&lang=js&external"
import style0 from "./PlayersFilter.vue?vue&type=style&index=0&id=067ae746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ae746",
  null
  
)

export default component.exports